export default (
  { role: roleDescriptor, caregiver, guardian, proxy, parent },
  formatMessage,
  additionalRole,
) => {
  if (!roleDescriptor) return null;

  const roles = [formatMessage({ id: `circles.roles.${roleDescriptor}` })];

  if (caregiver) {
    roles.push(formatMessage({ id: `circles.roles.caregiver` }));
  }

  if (guardian) {
    roles.push(formatMessage({ id: `circles.roles.guardian` }));
  }

  if (proxy) {
    roles.push(formatMessage({ id: `circles.roles.proxy` }));
  }

  if (parent) {
    roles.push(formatMessage({ id: `circles.roles.parent` }));
  }
  if (additionalRole) {
    roles.push(additionalRole);
  }

  return roles.join(', ');
};



// WEBPACK FOOTER //
// ./src/utils/converters/resolveFamilyMemberOption.js